export default __webpack_public_path__ + "media/images/affaire_fleche-prochaine-etape-57f68ccd4f56f5eb1b7746f499fac01d.png";